module.exports = __webpack_public_path__ + "img/cow_face.b80224ee.gif";